enum RelationshipType {
  Spouse = 1,
  Child = 2,
  DomesticPartner = 7,
}

export default RelationshipType;
